<template>
  <div class="container-fluid app app--red">
    <header class="app__title">
      <h1><span>ngo</span> partnership</h1>
    </header>
    <div class="row">
      <div class="col-lg-offset-1 col-lg-10">
        <div class="jumbotron">
          <p>Interested in implementing your project in a partnership with NGOs? This online database of NGOs from all of Europe will help you find the right organisation in just a few steps. Register your organisation and/or search the database for suitable organisations and find your NGO partner today.</p>
        </div>
      </div>
    </div>
    <div class="row tabs-container">
      <div class="tabs">
        <ul class="nav nav-tabs">
          <li v-for="(tab, index) in tabs" :key="tab.id" :class="{ active: activeTab === index }">
            <a :href="tab.link">{{tab.label}}</a>
            <div class="box__arrow-box"></div>
            <div class="box__arrow"></div>
          </li>
        </ul>
      </div>
    </div>
    <div class="filters clearfix">
      <div class="col-md-3">
        <input class="form-control" v-model="filterKeyword" placeholder="Filter by name">
      </div>
      <div class="col-md-3">
        <search-dropdown
          class="dropdown-filter"
          :items="filterCountries"
          :placeholder="filterCountriesPlaceholder"
        ></search-dropdown>
      </div>
      <div class="col-md-3">
        <search-dropdown
          class="dropdown-filter"
          :items="filterArea"
          :placeholder="filterAreaPlaceholder"
        ></search-dropdown>
      </div>
      <div class="col-md-3">
        <search-dropdown
          class="dropdown-filter"
          :items="filterActivities"
          :placeholder="filterActivitiesPlaceholder"
        ></search-dropdown>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th><button class="action" v-sortarrow="'name'">ORGANISATION</button></th>
            <th><button class="action" v-sortarrow="'countries'">COUNTRIES</button></th>
            <th><button class="action" v-sortarrow="'areas'">AREAS</button></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="data_ngos == null" class="no-hover">
            <td colspan="3">Loading...</td>
          </tr>
          <tr v-else-if="data_ngos.error" class="no-hover">
            <td colspan="3">Error while loading.</td>
          </tr>
          <tr v-else-if="filteredNgos && filteredNgos.length <= 0" class="no-hover">
            <td colspan="3">No results.</td>
          </tr>
          <tr v-else v-for="ngo in filteredNgos" :key="ngo.id" @click.prevent="openCover(ngo)">
            <td data-label="ORGANISATION">{{ngo.name}}</td>
            <td data-label="COUNTRIES">{{ngo.countries.join(', ')}}</td>
            <td data-label="AREAS">{{ngo.areas.join(', ')}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="content-container-cover" v-if="coverOpen && coverData">
      <div class="container-fluid app app--red">
        <div class="app__width-container">
          <div class="top-bar clearfix">
            <a class="top-bar__close" @click.prevent="closeCover" href="/ngo-partnership/">back to search results</a>
            <span class="top-bar__title"><span>ngo</span> partnership</span>
          </div>
          <div class="info__title">
            <small>ORGANISATION</small>
            <h1>{{coverData.name}}</h1>
          </div>
          <div class="row">
            <div class="col-md-4">
              <dl class="side-box side-box--bg">
                <dt>Countries</dt>
                <dd>{{coverData.countries && coverData.countries.join(', ')}}</dd>
                <dt>Areas covered</dt>
                <dd>{{coverData.areas && coverData.areas.join(', ')}}</dd>
                <dt>Activities</dt>
                <dd>{{coverData.activities && coverData.activities.join(', ')}}</dd>
                <dt>Function</dt>
                <dd>{{coverData.function && coverData.function.join(', ')}}</dd>
              </dl>
              <dl class="side-box side-box--border" v-if="coverData.contact">
                <dt>Postal Address</dt>
                <dd>
                  {{coverData.contact.address}}<br>
                  {{coverData.contact.zip}} {{coverData.contact.city}}<br>
                  {{coverData.contact.country}}
                </dd>
                <dt>Contact Info</dt>
                <dd>
                  <div v-if="coverData.contact.phone">{{coverData.contact.phone}}</div>
                  <div v-if="coverData.contact.email"><a class="line-ellipsis" :href="`mailto:${coverData.contact.email}`" target="_blank">{{coverData.contact.email}}</a></div>
                  <div v-if="coverData.contact.website"><a class="line-ellipsis" :href="coverData.contact.website" target="_blank">{{coverData.contact.website}}</a></div>
                </dd>
                <dt>Contact People</dt>
                <dd>
                  <template v-for="f in coverData.contact.people">
                    <div :key="f">{{f}}</div>
                  </template>
                </dd>
              </dl>
            </div>
            <div class="col-md-8 main-content">
              <div class="main-content__full-bg">
                <div v-html="coverData.description_short" v-externallinks class="block-paragraph"></div>
              </div>
              <div>
                <template v-if="coverData.description">
                  <div class="main-content__title">Description</div>
                  <div v-html="coverData.description" v-externallinks class="block-paragraph"></div>
                </template>
                <template v-if="coverData.references">
                  <hr>
                  <div class="main-content__title">References</div>
                  <ul class="main-content__list">
                    <li v-for="f in coverData.references" :key="f.label">
                      <a v-if="f.link && f.link.toLowerCase() !== 'null' && f.link.toLowerCase() !== 'http://null'" :href="f.link" target="_blank">{{f.label}}</a>
                      <a v-else-if="f.label && (f.label.indexOf('http://') === 0 || f.label.indexOf('https://') === 0) && f.label.toLowerCase() !== 'null' && f.label.toLowerCase() !== 'http://null'" :href="f.label" target="_blank">{{f.label}}</a>
                      <span v-else class="like-link">{{f.label}}</span>
                    </li>
                  </ul>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showRegisterModal">
      <div class="modal" tabindex="-1" role="dialog" style="display:block">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" @click.prevent="closeRegisterModal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title">Congratulations!</h4>
            </div>
            <div class="modal-body">
              <p>You have successfuly registered your NGO. Admin link was just sent to the email address you entered in the previous step.  You should keep that e-mail in case you want to edit your profile later on.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in" v-if="showRegisterModal"></div>
  </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import queryString from 'query-string';
import SearchDropdown from '../components/SearchDropdown.vue';
import { addMissingHTTP } from '../utils';

const qs = queryString.parse(window.location.search);

export default {
  name: 'app',
  created() {
    if (this.coverOpen || this.showRegisterModal) {
      const scroller = document.scrollingElement || document.documentElement;
      scroller.style.overflow = 'hidden';
    }
    this.locationChange(window.location);
    window.addEventListener('popstate', () => {
      this.locationChange(window.location);
    });
  },
  data() {
    return {
      tabs: [
        { id: 0, label: 'search ngos', link: '/ngo-partnership/' },
        { id: 1, label: 'create your profile', link: '/ngo-partnership/signup/' },
      ],
      filterCountries: [
        { id: 0, label: 'Albania', selected: false },
        { id: 1, label: 'Austria', selected: false },
        { id: 2, label: 'Azerbaijan', selected: false },
        { id: 3, label: 'Belarus', selected: false },
        { id: 4, label: 'Belgium', selected: false },
        { id: 5, label: 'Bosnia and Herzegovina', selected: false },
        { id: 6, label: 'Bulgaria', selected: false },
        { id: 7, label: 'Croatia', selected: false },
        { id: 8, label: 'Cyprus', selected: false },
        { id: 9, label: 'Czech Republic', selected: false },
        { id: 10, label: 'Denmark', selected: false },
        { id: 11, label: 'England', selected: false },
        { id: 12, label: 'Estonia', selected: false },
        { id: 13, label: 'Finland', selected: false },
        { id: 14, label: 'France', selected: false },
        { id: 15, label: 'Georgia', selected: false },
        { id: 16, label: 'Germany', selected: false },
        { id: 17, label: 'Greece', selected: false },
        { id: 18, label: 'Hungary', selected: false },
        { id: 19, label: 'Iceland', selected: false },
        { id: 20, label: 'Ireland', selected: false },
        { id: 21, label: 'Italy', selected: false },
        { id: 22, label: 'Kosovo', selected: false },
        { id: 23, label: 'Latvia', selected: false },
        { id: 24, label: 'Liechtenstein', selected: false },
        { id: 25, label: 'Lithuania', selected: false },
        { id: 26, label: 'Luxembourg', selected: false },
        { id: 27, label: 'Macedonia', selected: false },
        { id: 28, label: 'Malta', selected: false },
        { id: 29, label: 'Moldova', selected: false },
        { id: 30, label: 'Montenegro', selected: false },
        { id: 31, label: 'Netherlands', selected: false },
        { id: 32, label: 'Norway', selected: false },
        { id: 33, label: 'Northern Ireland', selected: false },
        { id: 34, label: 'Poland', selected: false },
        { id: 35, label: 'Portugal', selected: false },
        { id: 36, label: 'Romania', selected: false },
        { id: 37, label: 'Russia', selected: false },
        { id: 38, label: 'Serbia', selected: false },
        { id: 39, label: 'Scotland', selected: false },
        { id: 40, label: 'Slovakia', selected: false },
        { id: 41, label: 'Slovenia', selected: false },
        { id: 42, label: 'Spain', selected: false },
        { id: 43, label: 'Sweden', selected: false },
        { id: 44, label: 'Switzerland', selected: false },
        { id: 45, label: 'Turkey', selected: false },
        { id: 46, label: 'Ukraine', selected: false },
        { id: 47, label: 'Wales', selected: false },
      ],
      filterArea: [
        { id: 0, label: 'Anti-Corruption & Transparency', selected: false },
        { id: 1, label: 'Children & Youth', selected: false },
        { id: 2, label: 'Civic Education & Political Participation', selected: false },
        { id: 3, label: 'Civil Protection & Disaster Relief', selected: false },
        { id: 4, label: 'Consumer Protection', selected: false },
        { id: 5, label: 'Culture & Art', selected: false },
        { id: 6, label: 'Development Cooperation & Humanitarian Aid', selected: false },
        { id: 7, label: 'Disability & Independent Living', selected: false },
        { id: 8, label: 'Education', selected: false },
        { id: 9, label: 'Elderly', selected: false },
        { id: 10, label: 'Environment & Animals', selected: false },
        { id: 11, label: 'European Integration', selected: false },
        { id: 12, label: 'Gender Equality', selected: false },
        { id: 13, label: 'Health Care', selected: false },
        { id: 14, label: 'HIV/AIDS & Drug Abuse', selected: false },
        { id: 15, label: 'Housing & Homelessness', selected: false },
        { id: 16, label: 'Human Rights, Democracy & Equal Opportunities', selected: false },
        { id: 17, label: 'ICT', selected: false },
        { id: 18, label: 'Infrastructure Organization', selected: false },
        { id: 19, label: 'LGBTI', selected: false },
        { id: 20, label: 'Mental Health', selected: false },
        { id: 21, label: 'Science & Technology', selected: false },
        { id: 22, label: 'Social Enterprise', selected: false },
        { id: 23, label: 'Sports', selected: false },
        { id: 24, label: 'Tourism', selected: false },
        { id: 25, label: 'Violence Prevention', selected: false },
        { id: 26, label: 'Volunteering', selected: false },
        { id: 27, label: 'Other', selected: false },
      ],
      filterActivities: [
        { id: 0, label: 'Advocacy & Lobbying', selected: false },
        { id: 1, label: 'Campaigning, PR & Marketing', selected: false },
        { id: 2, label: 'Capacity Building', selected: false },
        { id: 3, label: 'Consultancy', selected: false },
        { id: 4, label: 'Education & Training', selected: false },
        { id: 5, label: 'Fundraising', selected: false },
        { id: 6, label: 'ICT', selected: false },
        { id: 7, label: 'Information Services', selected: false },
        { id: 8, label: 'Media & Publishing', selected: false },
        { id: 9, label: 'Research & Analysis', selected: false },
        { id: 10, label: 'Social Protection & Welfare Systems', selected: false },
        { id: 11, label: 'Think Tank', selected: false },
        { id: 12, label: 'Other', selected: false },
      ],
      filterKeyword: '',
      coverOpen: false,
      coverData: null,
      sortKey: null,
      sortReverse: false,
      data_ngos: null,
      showRegisterModal: !!qs.registered,
      activeTab: 0,
    };
  },
  computed: {
    filterCountriesSelected() {
      return this.filterCountries
        .filter(e => e.selected)
        .map(e => e.label);
    },
    filterCountriesPlaceholder() {
      const selected = this.filterCountriesSelected.length;
      if (!selected || selected === this.filterCountries.length) {
        return 'All countries';
      }
      return `Selected countries: ${selected}`;
    },
    filterAreaSelected() {
      return this.filterArea
        .filter(e => e.selected)
        .map(e => e.label);
    },
    filterAreaPlaceholder() {
      const selected = this.filterAreaSelected.length;
      if (!selected || selected === this.filterArea.length) {
        return 'All areas';
      }
      return `Selected areas: ${selected}`;
    },
    filterActivitiesSelected() {
      return this.filterActivities
        .filter(e => e.selected)
        .map(e => e.label);
    },
    filterActivitiesPlaceholder() {
      const selected = this.filterActivitiesSelected.length;
      if (!selected || selected === this.filterActivities.length) {
        return 'All activities';
      }
      return `Selected activities: ${selected}`;
    },
    filteredNgos() {
      if (this.data_ngos) {
        let filtered = this.data_ngos;
        if (this.filterCountriesSelected.length > 0 &&
            this.filterCountriesSelected.length !== this.filterCountries.length) {
          filtered = filtered.filter((e) => {
            if (e.countries) {
              return e.countries.some(v => this.filterCountriesSelected.indexOf(v) !== -1);
            }
            return false;
          });
        }
        if (this.filterAreaSelected.length > 0 &&
            this.filterAreaSelected.length !== this.filterArea.length) {
          filtered = filtered.filter((e) => {
            if (e.areas) {
              return e.areas.some(v => this.filterAreaSelected.indexOf(v) !== -1);
            }
            return false;
          });
        }
        if (this.filterActivitiesSelected.length > 0 &&
            this.filterActivitiesSelected.length !== this.filterActivities.length) {
          filtered = filtered.filter((e) => {
            if (e.activities) {
              return e.activities.some(v => this.filterActivitiesSelected.indexOf(v) !== -1);
            }
            return false;
          });
        }
        if (this.filterKeyword.trim()) {
          filtered = filtered.filter((e) => {
            if (e.name) {
              return e.name.toLowerCase().indexOf(this.filterKeyword.toLowerCase()) !== -1;
            }
            return false;
          });
        }
        if (this.sortKey) {
          filtered = _.sortBy(filtered, [(o) => {
            const val = _.get(o, this.sortKey);
            if (typeof val === 'string') {
              return val.toLowerCase();
            }
            return val;
          }]);
          if (this.sortReverse) {
            filtered = filtered.reverse();
          }
        }
        return filtered;
      }
      return this.data_ngos;
    },
  },
  watch: {
    coverOpen(value) {
      const scroller = document.scrollingElement || document.documentElement;
      if (value) {
        scroller.style.overflow = 'hidden';
      } else {
        scroller.style.overflow = '';
      }
    },
    showRegisterModal(value) {
      const scroller = document.scrollingElement || document.documentElement;
      if (value) {
        scroller.style.overflow = 'hidden';
      } else {
        scroller.style.overflow = '';
      }
    },
  },
  methods: {
    openCover(data) {
      this.coverData = data;
      this.coverOpen = true;
      if ('pushState' in history) {
        history.pushState(null, '', `/ngo-partnership/view/${data.id}/${data.slug}`);
        this.locationChange(window.location);
      }
    },
    closeCover() {
      this.coverOpen = false;
      if ('pushState' in history) {
        history.pushState(null, '', '/ngo-partnership/');
        this.locationChange(window.location);
      }
    },
    fetchData(url, key) {
      $.getJSON(url).done((data) => {
        data.forEach((e) => {
          if (!_.isArray(e.countries)) {
            e.countries = [e.countries];
          }
        });

        this[key] = data;
      }).fail(() => {
        const arr = [];
        arr.error = true;
        this[key] = arr;
      });
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortReverse = !this.sortReverse;
      } else {
        this.sortKey = key;
        this.sortReverse = false;
      }
    },
    closeRegisterModal() {
      this.showRegisterModal = false;
    },
    locationChange(loc) {
      if (loc.pathname === '/ngo-partnership/') {
        if (!this.data_ngos) {
          this.fetchData('/ngo-partnership/getNGOs/', 'data_ngos');
        }
        this.coverOpen = false;
        this.coverData = null;
        if (!this.sortKey) {
          this.sortKey = 'id';
          this.sortReverse = true;
        }
      } else {
        const m = loc.pathname.match(/\/view\/(\d+)\/.*$/);
        if (m && m[1]) {
          const id = parseInt(m[1], 10);
          $.getJSON(`/ngo-partnership/getNGO/${id}/`).done((data) => {
            if (!_.isArray(data.countries)) {
              data.countries = [data.countries];
            }
            if (_.isArray(data.references)) {
              data.references.forEach((ref) => {
                if (ref.link) {
                  ref.link = addMissingHTTP(ref.link);
                }
              });
            }
            if (data.contact && data.contact.website) {
              data.contact.website = addMissingHTTP(data.contact.website);
            }
            this.coverData = data;
            this.coverOpen = true;
          });
        }
      }
    },
  },
  directives: {
    externallinks(el) {
      $(el).find('a[href^="http://"],a[href^="https://"]').attr('target', '_blank');
    },
    sortarrow: {
      bind(el, binding, vnode) {
        el.sortArrowListener = () => {
          vnode.context.sortBy(binding.value);
        };
        el.addEventListener('click', el.sortArrowListener);
        el.classList.add('sortarrow');
        if (binding.value === vnode.context.sortKey) {
          el.classList.add('sortarrow--active');
          if (vnode.context.sortReverse) {
            el.classList.add('sortarrow--reverse');
          } else {
            el.classList.remove('sortarrow--reverse');
          }
        } else {
          el.classList.remove('sortarrow--active');
          el.classList.remove('sortarrow--reverse');
        }
      },
      update(el, binding, vnode) {
        if (binding.value === vnode.context.sortKey) {
          el.classList.add('sortarrow--active');
          if (vnode.context.sortReverse) {
            el.classList.add('sortarrow--reverse');
          } else {
            el.classList.remove('sortarrow--reverse');
          }
        } else {
          el.classList.remove('sortarrow--active');
          el.classList.remove('sortarrow--reverse');
        }
      },
      unbind(el) {
        el.removeEventListener('click', el.sortArrowListener);
        el.sortArrowListener = null;
      },
    },
  },
  components: {
    SearchDropdown,
  },
};
</script>



// WEBPACK FOOTER //
// src/ngopartnership/App.vue